import { useSendMessageRequest } from '../api/useSendMessageRequest';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { GetEventsKey } from './useReceiveEvents';
import { log } from '../lib/logger';
import { useCallback } from 'react';
export const useSendMessage = () => {
    const sendMessageRequest = useSendMessageRequest();
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: sendMessageRequest,
        onSuccess: () => {
            queryClient
                .invalidateQueries({ queryKey: [GetEventsKey] })
                .catch(log.error);
        },
    });
    return useCallback((vars) => mutation.mutateAsync(vars).then(response => response.sendMessage), [mutation]);
};
